import React from "react";
import img from "../img/oducal-campus.png";
import { ArrowRight } from "lucide-react";
import QuoteCard from "./QuoteCard";
const Campus = () => (
  <section className="campus-section">
    <div
      className="section-padding"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "4rem",
        alignItems: "center",
      }}
    >
      <div className="campus-content">
        <h3
          className="font-serif"
          style={{ fontSize: "3rem", marginBottom: "2rem" }}
        >
          UTPL, universidad sede del encuentro
        </h3>

        <QuoteCard></QuoteCard>
        
        <p style={{ color: "#d1d5db", fontSize: "1rem", lineHeight:"1.3", marginBottom: "2rem" }}>
          La Universidad Técnica Particular de Loja (UTPL), institución
          anfitriona del VIII Encuentro de la Red de Comunicadores de ODUCAL, es
          un espacio donde el conocimiento se conecta con el propósito y la
          formación se orienta a transformar realidades. Con identidad católica
          y una mirada global, la UTPL ha construido un modelo educativo
          innovador que pone en el centro a la persona y proyecta su impacto más
          allá de las aulas. Desde Loja hacia el mundo, su liderazgo en
          educación a distancia y en línea, y su apuesta por la transformación
          digital la han convertido en un referente en América Latina,
          integrando excelencia académica, tecnología y compromiso social. Como
          sede de este Encuentro, la UTPL invita a vivir una experiencia que
          combina pensamiento, innovación y sentido, en un entorno donde la
          comunicación no solo informa, sino que inspira y transforma.
        </p>
        <p
          style={{ color: "#d1d5db", fontSize: "1.5rem", marginBottom: "2rem" , lineHeight:"1.3"}}
        >
          <b> Nuestro propósito: </b>transformar vidas y contextos
        </p>
        <a target="_blank" href="https://utpl.edu.ec/acercade" className="link-button-1">
          <span>Conoce más de la universidad anfitriona</span>
          <ArrowRight size={18} />
        </a>
      </div>
      <div className="campus-image-container">
        <img
          src={img}
          alt="Campus"
          className="campus-image"
        />
      </div>
    </div>
  </section>
);

export default Campus;
